import React from 'react';
import Turnstile from 'react-turnstile';

export default function CloudflareCaptcha({
  siteKey,
  onVerify,
}) {
  return <Turnstile sitekey={siteKey} onVerify={onVerify} />;
}

